import React, { useState, useEffect } from 'react';
import './CommonComponentsStylings.css';

const DropDownInput = ({ options, disabled, required, label, name, defaultSelected = '', onSelect,hideDefaultSelect=false }) => {
  const [selectedOption, setSelectedOption] = useState(defaultSelected);

  useEffect(() => {
    setSelectedOption(defaultSelected);
  }, [defaultSelected]);

  const handleSelect = (event) => {
    const inputVal = event.target.value;
    setSelectedOption(inputVal);
    if (onSelect) {
      onSelect(event);
    }
  };

  return (
    <div className="dropdown-wrapper">
      <label htmlFor={label}>
        {label} {required ? <span style={{ color: 'red' }}>*</span> : ''}
      </label>
      <select
        className="dropdown-select"
        disabled={disabled}
        value={selectedOption}
        name={name}
        onChange={handleSelect}
      >
        <option value="" hidden={hideDefaultSelect}>Select</option>
        {options?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropDownInput;
